import FormHelper from "@/module/FormHelper";

export default class ForeignCustomerDeterminer {
  private readonly country: string;

  constructor(country: string) {
    this.country = country;
  }

  isForeignCustomer(customerCountry: string | null) {
    if (customerCountry === null) {
      return false;
    }

    return customerCountry !== this.country;
  }

  isCountryInEu(customerCountry: string | null) {
    if (customerCountry === null) {
      return false;
    }

    return FormHelper.euCountries.includes(customerCountry);
  }
}
